import { Component, OnInit } from '@angular/core';
import { formatDate } from '@angular/common';
import { first } from 'rxjs/operators';

import { AuthenticationService, NotificationService, KeywordService, RevenueShareRatioService } from '../../../_services';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  templateUrl: './revenue-share-ratio.component.html'
})
export class RevenueShareRatioComponent implements OnInit {
  urls: Array<any> = [];
  loading = false;
  processing = false;
  emptyResult = true;

  filterable = {
    shortCode: null,
    operator: null,
    source: null,
    country: null,
    year: null,
    month: null,
  };

  sourceList = [];
  countryList: any = {};
  keywordList: any =[];
  shortCodeList = [];
  operatorList: any = [];

  yearList = [];
  monthList = [
    { "name": 'January', "value": 1 },
    { "name": 'February', "value": 2 },
    { "name": 'March', "value": 3 },
    { "name": 'April', "value": 4 },
    { "name": 'May', "value": 5 },
    { "name": 'June', "value": 6 },
    { "name": 'July', "value": 7 },
    { "name": 'August', "value": 8 },
    { "name": 'September', "value": 9 },
    { "name": 'October', "value": 10 },
    { "name": 'November', "value": 11 },
    { "name": 'December', "value": 12 },
  ];

  constructor(private authSvc: AuthenticationService,
    private keywordSvc: KeywordService,
    private revenueShareRatioSvc: RevenueShareRatioService,
    private notification: NotificationService,
    private modalService: NgbModal) {

  }

  ngOnInit(): void {
    let dte = new Date();
    let currentYear = dte.getFullYear();
    this.yearList.push(currentYear);
    this.yearList.push(currentYear - 1);
    // goto previous 1 month
    if (dte.getMonth() >= 1) {
      this.filterable.year = currentYear;
      this.filterable.month = dte.getMonth();
    } else {
      this.filterable.year = currentYear - 1;
      this.filterable.month = 12 - dte.getMonth() + 2;
    }

    this.loadSources();
  }



  changeSource(source) {
    this.filterable.source = source;
    this.shortCodeList = [];
    this.keywordList = [];
    this.countryList = {};
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    this.filterable.country = null;
    if (source) {
      this.countryList = source.subOptions;
      var targetCountry = this.countryList[Object.keys(this.countryList)[0]];
      this.changeCountry(targetCountry);
    }
  }

  changeCountry(country) {
    this.filterable.country = country;
    this.shortCodeList = [];
    this.keywordList = [];
    this.operatorList = {};
    this.filterable.shortCode = null;
    this.filterable.operator = null;
    if (country) {
      this.keywordSvc.getSelectionShortCodes(this.filterable.source.value, country, "REVENUE_SHARE_RATIO").subscribe(data => {
        this.operatorList = data.data;
        this.filterable.operator = Object.keys(this.operatorList)[0];
        this.changeOperator(this.filterable.operator);
      });
    }
  }

  changeOperator(operator) {
    this.filterable.operator = operator;
    this.shortCodeList = [];
    this.keywordList = [];
    this.filterable.shortCode = null;
    if (operator) {
      this.shortCodeList = this.operatorList[operator];
    }
  }

  private loadSources() {
    this.keywordSvc.getSelectionSources("REVENUE_SHARE_RATIO").pipe(first()).subscribe(data => {
      this.sourceList = data.data;
      this.filterable.source = data.data[0];
      this.countryList = data.data[0].subOptions;
      var key = Object.keys(data.data[0].subOptions)[0];
      var value = data.data[0].subOptions[key];
      this.filterable.country = value;
      this.changeCountry(value);
    });
  }

  shareRatioExport() {
    this.loading = true;
    this.emptyResult = true;
    this.urls = [];
    let params = this.formParam();
    // get page of items from api
    this.revenueShareRatioSvc.export(params).pipe(first()).subscribe(data => {
      if (data.data != null) {
        this.loading = false;
        this.emptyResult = false;
        this.urls = data.data;
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no report for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  shareRatioWithDebtExport(){
    this.loading = true;
    this.emptyResult = true;
    this.urls = [];
    let params = this.formParam();
    // get page of items from api
    this.revenueShareRatioSvc.debtExport(params).pipe(first()).subscribe(data => {
      if (data.data != null) {
        this.loading = false;
        this.emptyResult = false;
        this.urls = data.data;
      } else {
        this.loading = false;
        this.emptyResult = true;
        var notiMsg = data.msg == "Awesome!" ? "There is no report for this search." : data.msg;
        this.notification.showWarning(notiMsg, "Empty Result");
      }
    });
  }

  private formParam() {
    var month;
    if (this.filterable.month >= 10) {
      month = "" + this.filterable.year + "-"+ this.filterable.month;
    } else {
      month = this.filterable.year + "-0" + this.filterable.month;
    }
    let params = {
      shortCode: this.filterable.shortCode,
      operator: this.filterable.operator,
      country: this.filterable.country,
      source: this.filterable.source.value,
      month: month,
    }
    return params;
  }

}
